"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var _1 = require("./");

var Close_1 = __importDefault(require("./svg/Close"));

var _2 = require("./");

var styled_1 = __importDefault(require("@emotion/styled"));

var StyledSidenav = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 100%;\n  min-width: 270px;\n  max-width: 80%;\n  margin-left: 10px;\n  padding-right: 10px;\n  transition: all 0.5s;\n  z-index: 999;\n  background: #ffffff;\n  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),\n    0 1px 10px 0 rgba(0, 0, 0, 0.12);\n  transform: ", ";\n  display: flex;\n  flex-direction: column;\n  overflow-y: hidden;\n\n  @media (min-width: 576px) {\n    min-width: 400px;\n  }\n"], ["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 100%;\n  min-width: 270px;\n  max-width: 80%;\n  margin-left: 10px;\n  padding-right: 10px;\n  transition: all 0.5s;\n  z-index: 999;\n  background: #ffffff;\n  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),\n    0 1px 10px 0 rgba(0, 0, 0, 0.12);\n  transform: ", ";\n  display: flex;\n  flex-direction: column;\n  overflow-y: hidden;\n\n  @media (min-width: 576px) {\n    min-width: 400px;\n  }\n"])), function (_a) {
  var open = _a.open;
  return open ? 'translate(-100%, 0)' : 'none';
});
var SidenavHeader = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.5);\n"], ["\n  padding: 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.5);\n"])));
exports.SidenavBody = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: ", "px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.5);\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: visible;\n"], ["\n  padding: ", "px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.5);\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: visible;\n"])), function (_a) {
  var _b = _a.padding,
      padding = _b === void 0 ? 0 : _b;
  return padding;
});
exports.SidenavFooter = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.5);\n"], ["\n  padding: 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.5);\n"])));
var SidenavCloseButton = styled_1.default.button(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background-color: transparent;\n  border: none;\n  outline: none;\n"], ["\n  background-color: transparent;\n  border: none;\n  outline: none;\n"])));
var SidenavClose = styled_1.default(Close_1.default)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  height: 20px;\n  width: 20px;\n  & path {\n    fill: #aaa;\n  }\n  &:hover,\n  &:focus {\n    color: black;\n    text-decoration: none;\n    cursor: pointer;\n  }\n"], ["\n  height: 20px;\n  width: 20px;\n  & path {\n    fill: #aaa;\n  }\n  &:hover,\n  &:focus {\n    color: black;\n    text-decoration: none;\n    cursor: pointer;\n  }\n"])));

exports.Sidenav = function (_a) {
  var children = _a.children,
      open = _a.open,
      onClose = _a.onClose,
      title = _a.title,
      _b = _a.closeLabel,
      closeLabel = _b === void 0 ? 'close' : _b;
  return react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement(_2.Backdrop, {
    open: open,
    onClose: onClose
  }), react_1.default.createElement(StyledSidenav, {
    open: open
  }, react_1.default.createElement(SidenavHeader, null, react_1.default.createElement(_1.Row, null, react_1.default.createElement(_1.Column, {
    flex: true
  }, title), react_1.default.createElement(_1.Column, null, react_1.default.createElement(SidenavCloseButton, {
    "aria-label": closeLabel,
    onClick: function onClick() {
      return onClose();
    }
  }, react_1.default.createElement(SidenavClose, null))))), children));
};

var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;